import { useState } from "react";
import {
  AltasTitularProvider,
  CancelacionMasivaProvider,
  EndosoContext,
} from ".";

export const EndosoProvider = ({ children }) => {
  const [alertData, setAlertData] = useState();
  const [checkedPersons, setCheckedPersons] = useState();
  const [showButtons, setShowButtons] = useState({});
  const [formDta, setFormDta] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [message, setMessage] = useState({});
  const [infoTable, setInfoTable] = useState([]);
  const [spinner, setSpinner] = useState(false);

  /* CargaB */
  const [cargaB, setCargaB] = useState({});
  const [cargaBData, setCargaBData] = useState({});

  /* Bajas 15 */
  const [bajaRiesgo15, setBajaRiesgo15] = useState();
  const [searchWord, setSearchWord] = useState("");
  const [selected, setSelected] = useState([]);

  /* descripcion 18 */
  const [autos, setAutos] = useState([]);
  const [auto, setAuto] = useState({});
  const [descripcion, setDescripcion] = useState();

  /* Bajas 23 */
  const [rows23, setRows23] = useState([]);
  const [continueR23, setContinueR23] = useState(false);
  const [infoTable23, setInfoTable23] = useState([]);

  /* beneficiario preferente 21 */
  const [finishR21, setFinishR21] = useState({});
  const [continue21, setContinue21] = useState(false);

  /* Alta 22 */
  const [dataR22, setDataR22] = useState([]);
  const [continueR22, setContinueR22] = useState(false);
  const [listErrors22, setListErrors22] = useState([]);
  const [finishR22, setFinishR22] = useState(false);
  const [numeroSituacion, setNumeroSituacion] = useState(1);

  /* endoso archivos */
  const [filesResponse, setFilesResponse] = useState([]);

  /* Nuevo Texto 24 */
  const [continueR24, setContinueR24] = useState(false);
  const [textoCargado24, setTextoCargado24] = useState(false);
  const [textoSalidaAlumnos24, setTextoSalidaAlumnos24] = useState({
    lugar: "",
    ubicacion: "",
    salida: null,
    horaSalida: null,
    regreso: null,
    horaRegreso: null,
    numeroAsegurados: "",
  });

  /* Datos fiscales 25 */
  const [showAlcanceRFC, setShowAlcanceRFC] = useState(false);
  const [totalRecibos, setTotalRecibos] = useState(0);
  const [confirmado25, setConfirmado25] = useState(false);
  const [showRefacturar, setShowRefacturar] = useState(false);
  const [recibos, setRecibos] = useState([]);
  const [paginaRecibos, setPaginaRecibos] = useState(0);
  const [totalPaginasRecibos, setTotalPaginasRecibos] = useState(0);
  const [recibosSeleccionados, setRecibosSeleccionados] = useState([]);
  const [loaderRecibos, setLoaderRecibos] = useState(false);

  const hideElement = (name, value) => {
    setShowButtons({ ...showButtons, [name]: value });
  };
  const createMessage = ({ text, variant, action, time }) => {
    setShowMessage(true);
    setMessage({
      text: text,
      severity: variant,
      action: action,
      time: time ?? 15000,
    });
  };
  const values = {
    alertData: alertData,
    setAlertData: setAlertData,
    checkedPersons: checkedPersons,
    setCheckedPersons: setCheckedPersons,
    showButtons,
    setShowButtons,
    formDta,
    setFormDta,
    showMessage,
    setShowMessage,
    message,
    setMessage,
    hideElement,
    createMessage,
    cargaB,
    setCargaB,
    cargaBData,
    setCargaBData,
    bajaRiesgo15,
    setBajaRiesgo15,
    searchWord,
    setSearchWord,
    selected,
    setSelected,
    autos,
    setAutos,
    auto,
    setAuto,
    descripcion,
    setDescripcion,
    infoTable,
    setInfoTable,
    filesResponse,
    setFilesResponse,
    spinner,
    setSpinner,
    finishR21,
    setFinishR21,
    continue21,
    setContinue21,
    dataR22,
    setDataR22,
    continueR22,
    setContinueR22,
    listErrors22,
    setListErrors22,
    finishR22,
    setFinishR22,
    rows23,
    setRows23,
    continueR23,
    setContinueR23,
    infoTable23,
    setInfoTable23,
    numeroSituacion,
    setNumeroSituacion,
    showAlcanceRFC,
    setShowAlcanceRFC,
    totalRecibos,
    setTotalRecibos,
    confirmado25,
    setConfirmado25,
    showRefacturar,
    setShowRefacturar,
    recibos,
    setRecibos,
    paginaRecibos,
    setPaginaRecibos,
    totalPaginasRecibos,
    setTotalPaginasRecibos,
    recibosSeleccionados,
    setRecibosSeleccionados,
    loaderRecibos,
    setLoaderRecibos,
    textoSalidaAlumnos24,
    setTextoSalidaAlumnos24,
    continueR24,
    setContinueR24,
    textoCargado24,
    setTextoCargado24,
  };

  return (
    <EndosoContext.Provider value={values}>
      <AltasTitularProvider>
        <CancelacionMasivaProvider>{children}</CancelacionMasivaProvider>
      </AltasTitularProvider>
    </EndosoContext.Provider>
  );
};
